import { render } from "./allCards.vue?vue&type=template&id=6236103e"
import script from "./allCards.vue?vue&type=script&lang=js"
export * from "./allCards.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__